'use strict';
import megatron from '@ibibo/megatron';
import {HotelsPaymentsInput} from './types';
import {commonUtils, roomStringUtils} from '@ibibo/hotel-utils';
import dateFormat from 'dateformat';
import querystring from 'query-string';
import {appConfig, apiConfig} from '@ibibo/hotels-config';

export function prepareHotelsPaymentsUrl({vcid, ci, co, ps, hc, rtc, rpc, ibp, ct, pc, oc, segmentid, subvendor}) {
  let url = `${apiConfig.__MYPARTNER__}/api/v1/hotels/provisional_booking`;
  url += `?query=hotels-${vcid}-${ci}-${co}-${ps}&hc=${hc}&rtc=${rtc}&rpc=${encodeURIComponent(rpc)}&ibp=${ibp}&contracttype=${ct}&promocode=${pc}`;
  url += oc ? `&offercode=${oc}` : '';
  url += segmentid ? `&segmentid=${segmentid}` : '';
  url += subvendor ? `&subvendor=${subvendor}` : '';
  return url;
}

export const hotelsPaymentsApi = async ({
  checkin,
  checkout,
  useGoCash,
  descblockResponse,
  descblockInput,
  travellerInfo,
  userInfo,
  earlycheckin,
  roomString,
  token
}: HotelsPaymentsInput) => {
  const {hc, rtc, rpc, pay_mode: pm, v, strQry, paxString, code, gsv, gseg} = descblockInput;

  const ci = dateFormat(checkin, 'yyyymmdd');
  const co = dateFormat(checkout, 'yyyymmdd');

  const {childrenCount,adultCount,roomConfig} = roomStringUtils.getRoomConfig(paxString);

  const {
    cdata,
    promocode = '',
    paas_pay_modes = {},
    paas_pay_modes_v2 = false,
    udf1,
  } = descblockResponse;

  const {goibibo_bookingcharges} = cdata?.farebreakup || 0;
  const ct = cdata?.contracttype || '';

  const {
    aftrpromototal,
    destination,
    HotelAddress,
    HotelName,
    gohtlid,
    checkin_display,
    checkout_display,
    city,
    country,
    Image,
    location,
    HotelRating,
    checkintime,
    max_gocash = 0,
    non_vested_gocash = 0,
    vested_gocash = 0,
    personalized_keys,
    pay_mode,
    payment_type,
    is_domestic,
    dispPromoBox,
    credits,
    total_credits = 0,
    vested_credits = 0,
    non_vested_credits = 0,
    is_pah,
    RoomTypeName,
    addon_list = [],
    offercode = '',
    fwdParams
  } = cdata;
  const [expected_checkin_time = appConfig.defaultCheckinTime] = checkintime.split(
    ' ',
  );
  const strQuery = strQry ? strQry.split('-') : [];
  const vcid = strQuery[1] || '';

  const qryDict = {
    user_latitude: '',
    user_longitude: '',
    vo: '',
    rpco: '',
    rtco: '',
    destination,
    fwdParams: fwdParams,
    vertical: 'hotels',
    checkin: ci,
    HotelAddress,
    noOfNights: commonUtils.noOfNights(checkout, checkin),
    HotelName,
    code: promocode.toUpperCase(),
    rooms: roomConfig.map(item => ({adults: item.adult, childs: item.childArray || []})),
    country_code: cdata.country_code,
    hc,
    voyagerid: vcid,
    gohtlid,
    checkin_display,
    city,
    rtc,
    noofAdults: adultCount,
    country,
    Image,
    checkout_display,
    rpc,
    newui: 'True',
    chkoutdate: co,
    noofChildren: childrenCount,
    location,
    strQry,
    v,
    chkindate: ci,
    noofRooms: roomConfig.length,
    checkout: co,
    HotelRating,
  };

  const {
    nameDetails,
    businessProfile = false,
    selectedCheckinTime,
    specialReq
  } = travellerInfo;

  const bookingData = {...cdata, paas_pay_modes_v2};
  // const {cn, sn, mail, country_code, mobileno} = userInfo;
  let paymentData = {
    vertical: 'hotels',
    productid: hc,
    voyagerid: hc,
    gohtlid: gohtlid || hc,
    qryDict: JSON.stringify(qryDict),
    bookingdata: JSON.stringify(bookingData),
    querydata: strQry,
    guest: 'guest',
    hiddenPrice: aftrpromototal,
    leadcodelist: '[]',
    code: promocode,
    amountCr: udf1,
    hiddenudf4: '',
    hiddenudf5: '',
    avoiddupe: '',
    fwdParams: fwdParams,
    internationalhotels: is_domestic === 1 ? 'False' : 'True',
    cityid: vcid,
    cityname: city || '',
    newui: 'True',
    dispPromoBox,
    partner: 'goibibo',
    actualamount: '',
    actualcredits: 0,
    paytype: 'goCashCards',
    totfare: aftrpromototal,
    cr_prod_name: 'gi.hotels.trip',
    otp: '',
    gocashpromocode: '',
    choose: nameDetails[0].nameTitle,
    email: travellerInfo.email,
    country_code: travellerInfo.countryCode,
    mobile: travellerInfo.phoneNumber,
    expected_checkin_time: selectedCheckinTime || expected_checkin_time,

    special_requests: specialReq || '',
    firstname: nameDetails[0].firstName,
    lastname: nameDetails[0].lastName,
    address: 'ibibo Web Private Limited, 5 th Floor, Good Earth City Centre,Sector 50,Gurgaon,Haryana - 122018.',
    city: city || '',
    pincode: '122002',
    state: 'Delhi',
    country: country || '',
    landline: '',
    credits: credits || '',
    payuId: '',
    password: '',
    total_credits,
    vested_credits,
    non_vested_credits,
    credits_amount: useGoCash ? max_gocash : 0, // revisit
    non_vested_gocash,
    vested_gocash,
    native_pay_amnt:
      (personalized_keys.np_wt !== undefined ? personalized_keys.np_wt : aftrpromototal) || 0,
    vertical_redmp: 0,
    go_pn: 1,
    go_pg: is_pah === 0 ? 'payu' : 'adyen',
    pay_mode: pay_mode || pm,
    payment_type,
    is_domestic,
    type: businessProfile ? 'business' : 'personal', // revisit
    pay_gst_number: travellerInfo.gstNumber || '',
    pay_gst_company_name: travellerInfo.companyName || '',
    pay_gst_business_email: travellerInfo.businessEmail || '',
    pay_gst_company_address: travellerInfo.companyAddress || '',
    pay_gst_phone_number: travellerInfo.companyPhone || '',
    gst_business_country: '',
    gst_business_state: '',
    customer_pan_no: travellerInfo.travellersPan || undefined,
    passPayModes: JSON.stringify(paas_pay_modes),
    paas_pay_modes_v2,
    addon_list: earlycheckin ? JSON.stringify(addon_list) : '',
  };

  let namesData = {};
  nameDetails.forEach(({nameTitle, firstName, lastName}, index: number) => {
    namesData = {
      ...namesData,
      [`firstname${index + 1}`]: firstName,
      [`lastname${index + 1}`]: lastName,
      [`title${index + 1}`]: nameTitle,
    };
  });

  paymentData = {...paymentData, ...namesData};

  const gstDetails = {
    gstn: travellerInfo.gstNumber || '',
    cname: travellerInfo.companyName || '',
    cemail: travellerInfo.businessEmail || '',
    caddress: travellerInfo.companyAddress || '',
    cphone: travellerInfo.companyPhone || '',
    ccountry: '',
    cstate: '',
  }

  const panDetails = {
    pan_number: travellerInfo.travellersPan || '',
    pan_name: travellerInfo.travellersPanName || '',
    pan_checked_time: travellerInfo.travellersPanTime || '',
  };


  let fwd = {};
  if(cdata.fwdParams){
    if(cdata.fwdParams.fwdparams){
      fwd = cdata.fwdParams.fwdparams[0]
    }else{
      fwd = cdata.fwdParams
    }
  }

  const dataObj = {
    pay_mode : 1,
    fwdp : JSON.stringify(fwd),
    customer_details : JSON.stringify({
      title: nameDetails[0].nameTitle,
      firstname: nameDetails[0].firstName,
      lastname: nameDetails[0].lastName,
      email: travellerInfo.email,
      mobile: travellerInfo.phoneNumber,
      country_phone_code: `+${travellerInfo.countryCode}`,
    }),
    gst_details: JSON.stringify(gstDetails),
    customer_data: JSON.stringify(nameDetails),
    pan_details: JSON.stringify(panDetails),
    extra_details: JSON.stringify(paymentData)
  }
  if (token && token !== '') {
    dataObj.token = token;
  }

  // paymentData = {...paymentData, ...dataObj};

  const url = prepareHotelsPaymentsUrl({vcid, ci, co, ps: paxString, hc, rtc, rpc, ibp: v, ct, pc: code, oc: offercode, segmentid:gseg , subvendor: gsv}); // have to be shifted to config package
  // const url = `${__payments__}`;
  // const data = querystring.stringify(paymentData);
  const data = querystring.stringify(dataObj);
  const response = await megatron({
    name: 'hotel payments api',
    type: 'POST',
    url,
    requestData: data,
    credentials: 'include',
    // credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      // Authorization: 'Basic YWRtaW46YWRtaW4='
    },
  });

  return response;
  // pg only
  // return {
  //   "data":{
  //     "firstname":"test",
  //     "email":"shahrukh6@go-mmt.com",
  //     "guest":"true",
  //     "amount":"6944",
  //     "gobookingid":"GOHTLIB2B57R3CFX",
  //     "udf1":"temp",
  //     "productinfo":"hotels-6771549831164675055-20200623-20200624-1-1_0",
  //     "pay_mode":1,
  //     "pay_session_id":"c8f2b5ad2bca4f64938afeccea6dec03",
  //     "status":true
  //   }
  // };

  // wallet only
  // return {
  //   "data":{
  //     "firstname":"test",
  //     "email":"shahrukh6@go-mmt.com",
  //     "guest":"true",
  //     "amount":"6944",
  //     "gobookingid":"GOHTLIB2B57R3CFX",
  //     "udf1":"temp",
  //     "productinfo":"hotels-6771549831164675055-20200623-20200624-1-1_0",
  //     "pay_mode":1,
  //     "url":"/hotels/thank-you/?id=NH4514054381200",
  //     "status":true
  //   }
  // };

  //pg + wallet
  // return {
  //   "data":{
  //     "firstname":"test",
  //     "email":"shahrukh6@go-mmt.com",
  //     "guest":"true",
  //     "amount":"6944",
  //     "gobookingid":"GOHTLIB2B57R3CFX",
  //     "udf1":"temp",
  //     "productinfo":"hotels-6771549831164675055-20200623-20200624-1-1_0",
  //     "pay_mode":1,
  //     "pay_session_id":"c8f2b5ad2bca4f64938afeccea6dec03",
  //     "status":true
  //   }
  // };
};
export default hotelsPaymentsApi;
